import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import { isSuperUser, isAdmin, getIdentityOrgId } from 'services/Authentication';
import SidenavDeveloperContent from './SidenavDeveloperContent';
import SidenavSuperuserContent from './SidenavSuperuserContent';
import SidenavAdminContent from './SidenavAdminContent';

class SidenavContent extends Component {
    linkClick(e) {
        e.preventDefault();
        console.log('link clicked');
    }

    componentDidMount() {
        const { history } = this.props;
        const that = this;
        const pathname = `javascript:void(0)${history.location.pathname}`; // get current path

        const subMenuLi = document.querySelectorAll('.sub-menu > li');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            };
        }

        const menuLi = document.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open');
                    }
                }
                this.classList.toggle('open');
                event.stopPropagation();
            };
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {
            (error) => error;
        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (error) {
            (error) => error;
        }

        return null;
    }

    render() {
        if (isSuperUser()) {
            return (
                <CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
                    <ul className="nav-menu">
                        <li className="nav-header">
                            <IntlMessages id="sidebar.main" />
                        </li>
                        <SidenavSuperuserContent />
                        <SidenavDeveloperContent />
                        {getIdentityOrgId() ? <SidenavAdminContent /> : null}
                    </ul>
                </CustomScrollbars>
            );
        } else if (isAdmin()) {
            return (
                <CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
                    <ul className="nav-menu">
                        <li className="nav-header">
                            <IntlMessages id="sidebar.main" />
                        </li>
                        <SidenavAdminContent />
                    </ul>
                </CustomScrollbars>
            );
        } else {
            // may be an admin user - they can get to their employee dashboard but will land on the org dashboard
            // otherwise it is a standard user - will default to the employee dashboard
            // only allow the option to go to the organisation dashboard if they have admin rights
            return (
                <CustomScrollbars className="scrollbar" style={{ height: 'calc(100vh - 70px)' }}>
                    <ul className="nav-menu">
                        <li className="nav-header">
                            <IntlMessages id="sidebar.main" />
                        </li>
                        <li className="menu no-arrow">
                            <NavLink to="/app/emp-dashboard/default">
                                <i className="zmdi zmdi-check-square zmdi-hc-fw" />
                                <span className="nav-text">
                                    <IntlMessages id="sidebar.agile.dashboard.employee" />
                                </span>
                            </NavLink>
                        </li>
                        {isAdmin() ? (
                            <li className="menu no-arrow">
                                <NavLink to="/app/org-dashboard/default">
                                    <i className="zmdi zmdi-check-square zmdi-hc-fw" />
                                    <span className="nav-text">
                                        <IntlMessages id="sidebar.agile.dashboard.organisation" />
                                    </span>
                                </NavLink>
                            </li>
                        ) : null}
                    </ul>
                </CustomScrollbars>
            );
        }
    }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js